var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVias(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46.229,
    height: 46.138,
    viewBox: "0 0 46.229 46.138",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4620",
    "data-name": "Group 4620",
    transform: "translate(0 -0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4443",
    "data-name": "Group 4443",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4661",
    "data-name": "Path 4661",
    d: "M715.134,105.677v-2.16a.6.6,0,0,1,.491-.586l.036-.006a.6.6,0,0,1,.7.586v2.17a.6.6,0,0,1-.666.591l-.035,0a.6.6,0,0,1-.524-.591",
    transform: "translate(-674.935 -88.362)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4653",
    "data-name": "Path 4653",
    d: "M443.817,33.221h-12.4a.546.546,0,0,1-.546-.546V32.5a.546.546,0,0,1,.546-.546h.1q11.189,0,22.378-.011a2.2,2.2,0,0,0,.983-.27,5.7,5.7,0,0,1,5.764.03,1.5,1.5,0,0,0,.788.185,15.335,15.335,0,1,0-16.1-18.095,9.422,9.422,0,0,0-.22,1.729c-.025,2.344-.01,4.69-.01,7.075h8.03V21.551c0-1.641-.009-3.281,0-4.922A7.3,7.3,0,1,1,460.67,23.9c-.194.009-.389.011-.583.011H431.426a.546.546,0,0,1-.546-.546V23.19a.546.546,0,0,1,.546-.546H433.9a4.932,4.932,0,0,1-1.744-4.346,4.675,4.675,0,0,1,1.62-3.063,4.848,4.848,0,0,1,6.357,0,4.706,4.706,0,0,1,1.651,3.694,4.993,4.993,0,0,1-1.729,3.681H443.8c0-.223,0-.429,0-.634.027-2.31-.076-4.63.107-6.928A16.484,16.484,0,0,1,455.84.642a16.609,16.609,0,1,1,9.03,31.966c-.162.045-.323.092-.572.164.213.078.341.125.47.171a3.837,3.837,0,0,1-2.24,7.336.736.736,0,0,0-.591.11,5.647,5.647,0,0,1-7.344.89,1.648,1.648,0,0,0-.164-.064v4.372a.546.546,0,0,1-.546.546h-.2a.546.546,0,0,1-.546-.546c0-1.764.005-3.528-.007-5.293a1.325,1.325,0,0,0-.154-.644,5.6,5.6,0,0,1,.008-6.151c.035-.058.063-.12.121-.23h-3.335V34.89a.644.644,0,0,1-1.288,0V33.259h-3.408V45.591a.546.546,0,0,1-.546.546h-.16a.546.546,0,0,1-.546-.546ZM454.405,22.58a1,1,0,0,0,.2.054c2.032,0,4.069.07,6.1-.023a6.02,6.02,0,1,0-6.294-5.992c-.01,1.447,0,2.893,0,4.34V22.58m6.581,11.07a4.385,4.385,0,1,0-6.043,6.32c1.815,1.5,4.793,1.249,6.018-.507a3.931,3.931,0,0,1,.025-5.812M436.949,15.328a3.552,3.552,0,1,0,3.567,3.495,3.533,3.533,0,0,0-3.567-3.495M466.09,36.554a2.559,2.559,0,1,0-2.529,2.585,2.57,2.57,0,0,0,2.529-2.585",
    transform: "translate(-430.873 0.001)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4654",
    "data-name": "Path 4654",
    d: "M660.44,38.037l-2.027-.8a.6.6,0,0,1-.361-.688l.017-.075a.6.6,0,0,1,.8-.416l2.048.809a.6.6,0,0,1,.3.854l-.035.061a.6.6,0,0,1-.735.256",
    transform: "translate(-625.909 -30.923)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4655",
    "data-name": "Path 4655",
    d: "M612.61,33.7l2.152-.433a.6.6,0,0,1,.711.535l.006.076a.6.6,0,0,1-.474.633l-2.13.437a.6.6,0,0,1-.678-.377l-.029-.08a.6.6,0,0,1,.442-.79",
    transform: "translate(-586.498 -28.551)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4656",
    "data-name": "Path 4656",
    d: "M575.064,52.906l1.612-1.491a.6.6,0,0,1,.885.086l.045.061a.6.6,0,0,1-.074.787l-1.591,1.482a.6.6,0,0,1-.776.031l-.067-.053a.6.6,0,0,1-.034-.9",
    transform: "translate(-554.508 -44.009)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4657",
    "data-name": "Path 4657",
    d: "M663.008,183.442l-.021-.073a.6.6,0,0,1,.316-.708l1.971-.934a.6.6,0,0,1,.746.2l.043.063a.6.6,0,0,1-.237.87l-1.989.95a.6.6,0,0,1-.828-.37",
    transform: "translate(-630.142 -155.975)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4658",
    "data-name": "Path 4658",
    d: "M696.642,61.169l.053-.058a.6.6,0,0,1,.924.06l1.269,1.794a.6.6,0,0,1-.218.876l-.065.033a.6.6,0,0,1-.758-.187L696.6,61.913a.6.6,0,0,1,.045-.744",
    transform: "translate(-658.925 -52.303)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4659",
    "data-name": "Path 4659",
    d: "M557.445,89.623l-.457,2.124a.594.594,0,0,1-.625.469l-.081-.006a.6.6,0,0,1-.534-.718l.458-2.146a.6.6,0,0,1,.792-.433l.071.027a.6.6,0,0,1,.376.684",
    transform: "translate(-538.082 -76.304)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4660",
    "data-name": "Path 4660",
    d: "M699.8,150.1l1.135-1.859a.6.6,0,0,1,.739-.239l.07.029a.6.6,0,0,1,.274.855l-1.139,1.882a.6.6,0,0,1-.89.15l-.06-.05a.6.6,0,0,1-.129-.77",
    transform: "translate(-661.693 -127.031)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4662",
    "data-name": "Path 4662",
    d: "M556.108,138.543h-.019a.6.6,0,0,1-.6-.6v-2.133a.6.6,0,0,1,.6-.6h.019a.6.6,0,0,1,.6.6v2.133a.6.6,0,0,1-.6.6",
    transform: "translate(-537.872 -116.096)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4663",
    "data-name": "Path 4663",
    d: "M477.716,193.884h0a.6.6,0,0,1,.6-.6h2.139a.6.6,0,0,1,0,1.19h-2.139a.6.6,0,0,1-.6-.6",
    transform: "translate(-471.089 -165.95)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4664",
    "data-name": "Path 4664",
    d: "M524.174,193.848v-.013a.6.6,0,0,1,.6-.6H526.9a.6.6,0,0,1,.595.6v.013a.6.6,0,0,1-.595.6h-2.132a.6.6,0,0,1-.6-.6",
    transform: "translate(-510.978 -165.913)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4665",
    "data-name": "Path 4665",
    d: "M574.137,193.852v.009a.6.6,0,0,1-.6.6h-2.129a.6.6,0,0,1-.6-.6v-.009a.6.6,0,0,1,.6-.6h2.129a.6.6,0,0,1,.6.6",
    transform: "translate(-551.023 -165.926)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4666",
    "data-name": "Path 4666",
    d: "M619.974,194.525h-2.131a.6.6,0,0,1-.6-.6v-.011a.6.6,0,0,1,.6-.6h2.131a.6.6,0,0,1,.6.6v.011a.6.6,0,0,1-.6.6",
    transform: "translate(-590.891 -165.98)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4667",
    "data-name": "Path 4667",
    d: "M556.107,272.424H556.1a.6.6,0,0,1-.6-.6v-1.512a.6.6,0,0,1,.6-.6h.006a.6.6,0,0,1,.6.6v1.512a.6.6,0,0,1-.6.6",
    transform: "translate(-537.879 -231.573)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVias);
export default __webpack_public_path__ + "static/media/Vias.057fa484f0cdef65c8a6ac7edfba67d5.svg";
export { ForwardRef as ReactComponent };